
import { reactive, toRefs } from 'vue'
import { ElMessage } from 'element-plus'
import { recordquerybysupplier } from '@/api/record/index'
import filesaver from 'file-saver'
import * as XLSX from 'xlsx'
export default ({
  name: 'record',
  setup () {
    const state:any = reactive({
      isShowDialog: false,
      defaultdate: [],
      recordlist: [],
      row: {}
    })

    const dt = new Date()
    state.defaultdate.push(dt.getFullYear() + '-01-01')
    state.defaultdate.push(dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate())
    // 打开弹窗
    const openDialog = (row?: any) => {
      state.row = row
      getrecord(row)
      state.isShowDialog = true
    }
    // 关闭弹窗
    const closeDialog = (row?: object) => {
      console.log(row)
      state.isShowDialog = false
    }
    const search = () => {
      getrecord(state.row)
    }
    async function getrecord (row:any) {
      state.loading = true
      const recordlist = await recordquerybysupplier({ filterstring: row.dwbh, sdate: state.defaultdate[0], edate: state.defaultdate[1] })
      state.recordlist = JSON.parse(JSON.stringify(recordlist))
      ElMessage.success('查询成功')
    }
    const exportExcel = () => {
      /* out-table关联导出的dom节点 */
      var wb = XLSX.utils.table_to_book(document.querySelector('#out-recordtable'))
      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        filesaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '流向.xlsx')
      } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
      return wbout
    }
    const formatDate = (row:any, column:any) => {
      // 获取单元格数据
      const data = row[column.property]
      if (data == null) {
        return null
      }
      const dt = new Date(data)
      return dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate()
    }
    // 获取用户信息
    return {
      openDialog,
      closeDialog,
      search,
      exportExcel,
      formatDate,
      ...toRefs(state)
    }
  }

})
